<template>
	<pop-up-wrapper @close="this.$emit('close')">
		<div class="pop-up-edit-ai-generated">
			<img
				class="close"
				@click="this.$emit('close')"
				src="/img/close.svg"
				alt=""
			/>
			<form @submit.prevent="submit">
				<div class="input-container">
					<label for="Title">Title</label>
					<input
						type="text"
						v-model="clonedQuestion.title"
						id="Title"
						placeholder="Title"
					/>
				</div>
				<div class="input-container">
					<label for="Description">Question </label>
					<LatexEditor :text="clonedQuestion.description" :custom-id="`description`" @update-text="updateDescription" />
				</div>
				<div class="input-container">
					<label for="Correction">Correction </label>
					<LatexEditor :text="clonedQuestion.correction" :custom-id="`correction`" @update-text="updateCorrection" />
				</div>
					
				<button class="submit dark">Valider</button>
			</form>
		</div>
	</pop-up-wrapper>
</template>

<script>
import LatexEditor from '../../Utils/LatexEditor.vue'
import PopUpWrapper from '../PopUpWrapper.vue'
export default {
	components: { PopUpWrapper, LatexEditor },
	emits: ['close'],
	props: {
		question: Object,
	},
	data() {
		return {
			clonedQuestion: {},
		}
	},
	
	methods: {
		updateDescription(text){
			this.clonedQuestion.description = text
		},
		updateCorrection(text){
			this.clonedQuestion.correction = text
		},
		submit(){
			this.$emit('editQuestion', this.clonedQuestion)
			this.$emit('close')
		}
	},
	

	created() {
		this.clonedQuestion = JSON.parse(JSON.stringify(this.question))
	},

}
</script>

<style scoped lang="scss">
.pop-up-edit-ai-generated{
	width: 40vw;
	height: fit-content;
	max-height: 90vh;
	overflow: auto;
	position: relative;
	padding: 4rem;

	button{
		margin-inline: auto;
	}

	.input-container{
		margin-bottom: 2rem;

		input {
			background-color: inherit !important	;
			width: 100%;
			height: 100%;
			min-height: 2rem;
			padding: 2rem;
			border: 2px solid #000;
			border-radius: 15px;
		}
	}
}
</style>
